// extracted by mini-css-extract-plugin
module.exports = {"detail_new":"styles_detail_new__ZMBuv","header":"styles_header__kHShN","back":"styles_back__ivd31","title":"styles_title__MHl__","content":"styles_content__2vzBN"};